import { render, staticRenderFns } from "./example-charge-point.vue?vue&type=template&id=40c56363"
import script from "./example-charge-point.vue?vue&type=script&lang=js"
export * from "./example-charge-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports